export const TransactionCategory = {
  ALL: 'all',
  EARNED: 'earned',
  USED: 'used',
  EXPIRED: 'expired',
} as const;

export type TransactionCategory = (typeof TransactionCategory)[keyof typeof TransactionCategory];
